<template>
  <p
    :id="formWarningId"
    data-slot="form-warning"
    :class="
      cn(
        'flex items-start gap-2 text-sm text-foreground',
        joined && 'rounded-b-md border border-t-0 border-warning/45 bg-warning/10 px-3 py-1.5',
      )
    "
  >
    <TriangleAlertIcon class="mt-0.5 size-4 shrink-0 text-warning" aria-hidden="true" />
    <span class="min-w-0">{{ text }}</span>
  </p>
</template>

<script setup lang="ts">
// A checkbox has no box to join, so it passes `joined` off.
import { TriangleAlertIcon } from "lucide-vue-next";

import { useFormField } from "@/components/ui/form/useFormField";
import { cn } from "@/lib/utils";

withDefaults(defineProps<{ text: string; joined?: boolean }>(), { joined: true });

const { formWarningId } = useFormField();
</script>
